import { useEffect, useRef } from "react";

const Moodle = ({ Carnet, password, setShowMoodle }) => {

    let form = useRef();
    let runInitialFetch = true

    useEffect(() => {
        if (runInitialFetch) {
            form.current.submit();
            runInitialFetch = false
            setShowMoodle(false)
        }
    }, [runInitialFetch])

    return (
        <form action="https://www.imb-pc.com/moodle/login/index.php" method="post" ref={form} target="_blank">
            <input type="hidden" name="username" value={Carnet} />
            <input type="hidden" name="password" value={password} />
        </form >
    );
}

export default Moodle